var _rect, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrrows(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 775,
    height: 273,
    viewBox: "0 0 775 273",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 775,
    height: 273,
    rx: 24,
    fill: "#8C52FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M339.198 67.9458C343.546 63.5997 344.847 57.0626 342.492 51.3823C340.139 45.7021 334.598 42 328.448 42H296.201C287.807 42 281 48.8039 281 57.1985V89.4428C281 95.59 284.705 101.134 290.385 103.487C296.065 105.839 302.602 104.539 306.951 100.19L312.31 94.8331L372.199 154.098L372.181 239.599C372.181 247.993 379.005 254.8 387.4 254.8C395.795 254.8 402.583 247.993 402.583 239.599L402.601 154.098L462.472 94.8126L467.849 100.19C472.198 104.539 478.735 105.839 484.415 103.487C490.095 101.134 493.8 95.59 493.8 89.4428V57.1985C493.8 48.8039 486.993 42 478.599 42H446.352C440.202 42 434.661 45.7021 432.308 51.3823C429.953 57.0626 431.254 63.5997 435.602 67.9458L440.972 73.3155L387.4 127.498L333.807 73.3361L339.198 67.9458Z",
    fill: "#FFE457"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M387.395 254.8C395.789 254.8 402.578 247.993 402.578 239.599L402.596 154.098L462.466 94.8126L467.844 100.19C472.192 104.539 478.729 105.839 484.41 103.487C490.09 101.134 493.795 95.59 493.795 89.4428V57.1985C493.795 48.8039 486.988 42 478.593 42H446.347C440.197 42 434.655 45.7021 432.303 51.3823C429.947 57.0626 431.248 63.5997 435.597 67.9458L440.967 73.3155L387.395 127.498V254.8Z",
    fill: "#FFC83C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrrows);
export default __webpack_public_path__ + "static/media/arrrows.4a42c776bf1734e8cb6f3d6da1f84c14.svg";
export { ForwardRef as ReactComponent };